module.exports = __webpack_public_path__ + "img/hubba.e9f0fd91.png";